import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  margin-top: 16px;
  div.input-wrapper {
    display: flex;
    justify-content: space-between;

    &__left {
      max-width: 170px;
      width: 100%;
      padding-top: 16px;
    }

    &__right {
      width: 100%;
      margin-left: 45px;
    }
  }

  div.button-wrapper {
    width: 100%;
    button {
      display: block;
      margin-left: auto;
    }
  }

  .svg-icon--checked {
    svg {
      rect {
        fill: #346ffe;
      }
      g > g > g {
        fill: #346ffe;
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    margin-top: 0;

    button {
      height: 40px;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: 0.5px;
      height: 40px;
    }

    div.input-wrapper {
      flex-direction: column;

      &__left {
        padding-top: 0;

        h6 {
          font-size: 16px;
        }
      }

      &__right {
        margin-left: 0px;
        margin-bottom: 16px;
      }
    }
  }
`;
